import { useTranslations } from 'next-intl';
import React from 'react';
import { Wide } from '@mentimeter/content-ui/Layout';
import { H1, P } from '../Typography';
import { Error } from '../Error/Error';
import type { ContentUserT } from '../../state/user';
import WordCloud404 from './images/WordCloud404';

export function NotFound({ user }: { user: ContentUserT }) {
  const t = useTranslations('first_impression.error');
  return (
    <Error user={user}>
      <Wide width="90vw" mb="space8" alignItems="center">
        <WordCloud404 aria-label={t('not_found_aria_label')} width="100%" />
      </Wide>
      <H1 textAlign="center" fontWeight="bold">
        {t('not_found_title')}
      </H1>
      <P textAlign="center">{t('not_found_description')}</P>
    </Error>
  );
}
